import React from "/vendor/react";
import PropTypes from "prop-types";

import { FilterParamMap } from "/lib/util/filterParams";

import { createStyledComponent } from "/lib/component/util";
import { Chip as MUIChip } from "/vendor/@material-ui/core";

// TODO: Remove `any` types once `createStyledComponent` is fully annotated
const Chip = (createStyledComponent as any)({
  name: "FilterList.Chip",
  component: MUIChip,
  styles: (theme: any) => {
    const margin = theme.spacing(0.5);
    return {
      marginRight: margin,
      marginBottom: margin,
    };
  },
});

const Key = createStyledComponent({
  name: "FilterList.Key",
  component: "span",
  styles: () => ({ marginRight: "0.125rem" }),
});

const Em = createStyledComponent({
  name: "FilterList.Em",
  component: "span",
  styles: () => ({ fontStyle: "italic" }),
});

interface Props {
  filters: FilterParamMap;
  onChange(action: (prevFilters: FilterParamMap) => FilterParamMap): void;
}

const FilterList = ({ filters, onChange }: Props) => {
  const statusMapping = {
    " event.check.status notin [\"0\", \"1\", \"2\"]": "Status: Failing",
    " event.check.status == \"1\"": "Status: Warning",
    " event.check.status == \"2\"": "Status: Critical",
    " event.check.status notin [\"0\"]": "Status: Incident",
    " event.check.status == \"0\"": "Status: Passing",
  }

  const updateFilters = filters.fieldSelector ? { ...filters, fieldSelector: statusMapping[filters.fieldSelector]} : filters

  const chips = Object.keys(updateFilters)
    .sort()
    .map((key) => (
      <Chip
        key={key}
        onDelete={
          onChange
            ? () => onChange((filters) => ({ ...filters, [key]: undefined }))
            : undefined
        }
        label={
          <React.Fragment>
            <Key>{key}</Key>
            <Em>{updateFilters[key]}</Em>
          </React.Fragment>
        }
      />
    ));

  return <div>{chips}</div>;
};

FilterList.propTypes = {
  filters: PropTypes.object.isRequired,
  onChange: PropTypes.func,
};

FilterList.defaultProps = {
  onChange: undefined,
};

export default FilterList;
